export default [
  {
    path: '/app/products',
    name: 'Products',
    component: () => import('@/views/Products/Index.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'PRODUCTS_LIST',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/archive',
    name: 'ProductsArchive',
    component: () => import('@/views/Products/Archive.vue'),
    meta: {
      navActiveLink: 'Products',
      archived: true,
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Arşiv',
          active: true,
        },
      ],
      resource: 'PRODUCTS_ARCHIVE',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/add',
    name: 'ProductAdd',
    component: () => import('@/views/Products/Add.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'PRODUCTS_ADD',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Products/Edit.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'PRODUCTS_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/view/:id',
    name: 'ProductView',
    component: () => import('@/views/Products/View.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'PRODUCTS_VIEW',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id/prices/add',
    name: 'ProductPricesAdd',
    component: () => import('@/views/Products/Prices/Add.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürün Fiyatları',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Fiyat Ekle',
          active: true,
        },
      ],
      resource: 'PRODUCT_PRICES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id/prices/edit/:id_product_prices',
    name: 'ProductPricesEdit',
    component: () => import('@/views/Products/Prices/Edit.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürün Fiyatları',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Fiyat Güncelle',
          active: true,
        },
      ],
      resource: 'PRODUCT_PRICES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id/files/add',
    name: 'ProductFilesAdd',
    component: () => import('@/views/Products/Files/Add.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürün Dosyaları',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'PRODUCT_FILES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id/files/add-secret',
    name: 'ProductFilesAdd',
    component: () => import('@/views/Products/Files/AddSecret.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürün Dosyaları',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'PRODUCT_FILES_ADD_SECRET',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_SECRET_FILES',
        limit: 1,
      },
    },
  },
  {
    path: '/app/products/edit/:id/files/edit/:id_product_files',
    name: 'ProductFilesEdit',
    component: () => import('@/views/Products/Files/Edit.vue'),
    meta: {
      navActiveLink: 'Products',
      pageTitle: 'Ürün Dosyaları',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Dosya Güncelle',
          active: true,
        },
      ],
      resource: 'PRODUCT_FILES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'PRODUCTS_MANAGE',
        limit: 1,
      },
    },
  },
]
